import React, { useEffect, useState } from 'react';
import { fetchHebrewGreekAnalysis } from '../services/iqbibleVerseResources';

const HebrewGreekAnalysis = ({ bookName, chapter, verse }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!bookName || !chapter || !verse) return;
    setLoading(true);
    setError(null);
    setData(null);
    fetchHebrewGreekAnalysis({ bookName, chapter, verse })
      .then(res => setData(res))
      .catch(() => setError('Failed to load analysis.'))
      .finally(() => setLoading(false));
  }, [bookName, chapter, verse]);

  return (
    <div>
      <h4 className="hebrew-analysis-header">
        Hebrew/Greek Analysis for {bookName} {chapter}:{verse}
      </h4>
      <div className="analysis-section">
        <div className="original-text">
          <h5>Original Text</h5>
          <p>{loading ? 'Loading...' : (data && data.length > 0 ? data.map(w => w.word).join(' ') : 'No original text available')}</p>
        </div>
        <div className="transliteration">
          <h5>Transliteration</h5>
          <p>{loading ? 'Loading...' : (data && data.length > 0 ? data.map(w => {
            // Prefer 'dic_mod', fallback to 'dic', fallback to 'sbl' from pronun JSON
            let pronun = {};
            try { pronun = w.pronun ? JSON.parse(w.pronun) : {}; } catch {}
            return pronun.dic_mod || pronun.dic || pronun.sbl || '';
          }).join(' ') : 'No transliteration available')}</p>
        </div>
        <div className="word-analysis">
          <h5>Word Analysis</h5>
          {loading ? (
            <p>Loading...</p>
          ) : (
            data && data.length > 0 ? (
              <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
                {data.map((word, idx) => (
                  <li key={idx} style={{ marginBottom: '12px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
                    <strong>{word.original}</strong> <em>({word.transliteration})</em> {word.strongs ? <span>Strongs: {word.strongs}</span> : null}<br/>
                    <span>{word.glossary || word.translation || ''}</span>
                    {word.morphology && (<div style={{ color: '#6366f1', fontSize: '13px' }}>Morphology: {word.morphology}</div>)}
                    {word.partOfSpeech && (<div style={{ color: '#10b981', fontSize: '13px' }}>Part of Speech: {word.partOfSpeech}</div>)}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No word-by-word analysis available</p>
            )
          )}
        </div>
      </div>
      {error && <div style={{ color: '#ef4444', marginTop: '12px' }}>{error}</div>}
    </div>
  );
};

export default HebrewGreekAnalysis;
